import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 页面组件
import Home from './pages/home';
import Projects from './pages/projects';
import Blog from './pages/blog';
import About from './pages/about';
import Contact from './pages/contact';
import Login from './pages/login';
import Products from './pages/products';



import PreLoader from './components/UI/preLoader/preLoader';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查 sessionStorage 中是否有预加载器标志
    const hasVisited = sessionStorage.getItem('hasVisited');

    if (!hasVisited) {
      // 如果是首次访问，显示预加载器并设置标志
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('hasVisited', 'true');
      }, 3000); // 2秒后停止加载

      return () => clearTimeout(timer);
    } else {
      // 如果不是首次访问，直接设置加载状态为 false
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <PreLoader />;
  }

  return (
    <Router>
      <div className="font-roboto">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/products" element={<Products />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
